"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTableData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
const MoreHoriz_1 = __importDefault(require("@mui/icons-material/MoreHoriz"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const roles_1 = __importDefault(require("../../../../../common/constants/roles"));
const appConstants_1 = require("../../../../constants/appConstants");
const teamQuery_1 = require("../../../../queries/teamQuery");
const zustandStore_1 = require("../../../../zustandStore");
const _1 = require(".");
const getRoleLabel = ({ user, teamID, roles }) => {
    const role = lodash_1.default.find(user?.roles, { securityGroupId: teamID });
    return role ? lodash_1.default.find(roles, { id: role.roleId })?.label : '';
};
const useGetTableData = () => {
    const currentNameSearchValue = (0, zustandStore_1.useZustand)(state => state.peopleTable.currentNameSearchValue);
    const pageId = (0, zustandStore_1.useZustand)(state => state.peopleTable.pager.pageId);
    const { data: teamId } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const { data, isFetching } = (0, teamQuery_1.useGetTeamUsersQuery)({
        page: pageId,
        teamId: teamId?.[0] || '',
        limit: _1.LIMIT,
        searchParam: currentNameSearchValue,
    });
    const { setPeopleTablePagerNumPages, setPeopleTablePagerPageId, setIsUserRoleAsideOpen, setCurrentUserRoleAside, setIsUserDetailsAsideOpen, setIsUserApproverAsideOpen, setCurrentUserDetailsAside, } = (0, zustandStore_1.useZustand)();
    const teamID = typeof teamId === 'object' ? teamId?.[0] : teamId;
    (0, react_1.useEffect)(() => {
        if (!data) {
            return;
        }
        setPeopleTablePagerNumPages(data?.numPages || 0);
        setPeopleTablePagerPageId(data?.pageId || 0);
    }, [data, setPeopleTablePagerNumPages, setPeopleTablePagerPageId]);
    if (data?.users && data.users.length > 0) {
        const cellData = data?.users.map(user => [
            {
                id: 'Name',
                ui() {
                    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, direction: "column", children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", "ts-variant": 'tableCellTitleName', children: lodash_1.default.escape(user?.fullName) }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle1", "ts-variant": 'tableCellSubtitle', children: user?.email })] }));
                },
            },
            {
                id: 'role',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Button, { color: 'secondary', size: 'small', variant: 'outlined', style: {
                            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    fontWeight: 400,
                                    color: '#000000',
                                    textTransform: 'none',
                                }
                                : {}),
                        }, onClick: () => {
                            const roleId = lodash_1.default.camelCase(user?.roles[0]?.roleId);
                            setCurrentUserDetailsAside(user);
                            setCurrentUserRoleAside(roles_1.default[roleId]);
                            setIsUserRoleAsideOpen(true);
                        }, endIcon: (0, jsx_runtime_1.jsx)(Menu_1.default, {}), children: getRoleLabel({ user, teamID, roles: roles_1.default }) }));
                },
            },
            {
                id: 'approver',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Button, { color: 'secondary', size: 'small', variant: 'outlined', style: {
                            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    fontWeight: 400,
                                    color: '#000000',
                                    textTransform: 'none',
                                }
                                : {}),
                        }, onClick: () => {
                            setCurrentUserDetailsAside(user);
                            setIsUserApproverAsideOpen(true);
                        }, endIcon: (0, jsx_runtime_1.jsx)(Menu_1.default, {}), children: lodash_1.default.get(user, `teams[${teamId}].approver`)
                            ? lodash_1.default.escape(String(user.teams[teamID || '']?.['approver']?.fullName))
                            : ' -- ' }));
                },
            },
            {
                id: 'status',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", style: {
                            textTransform: 'uppercase',
                            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    fontWeight: 400,
                                    color: '#000000',
                                    textTransform: 'none',
                                }
                                : {}),
                        }, children: appConstants_1.userStateToStatus[user?.state] }));
                },
            },
            {
                id: 'teamActions',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "row", sx: {
                            justifyContent: 'flex-end',
                            alignItems: 'flex-end',
                        }, children: (0, jsx_runtime_1.jsx)(material_1.Button, { variant: "text", "ts-variant": "actionButton", onClick: () => {
                                setCurrentUserDetailsAside(user);
                                setIsUserDetailsAsideOpen(true);
                            }, endIcon: (0, jsx_runtime_1.jsx)(MoreHoriz_1.default, {}) }) }));
                },
            },
        ]);
        return { cellData, isFetching };
    }
    return { cellData: [], isFetching };
};
exports.useGetTableData = useGetTableData;
